module.exports = __webpack_public_path__ + "assets/img/00060.20b57c8b.png";